// extracted by mini-css-extract-plugin
module.exports = {"Component":"RadioConvenience_Component__2thOT"};